// Filename - src/goodiebagscanner.js

import React, { useEffect, useState } from "react";
import { db, auth } from "./firebase";
import { Link, useLocation, useNavigate } from "react-router-dom";
import QrReader from "react-qr-reader";
import { useAuthState } from "react-firebase-hooks/auth";
import {  getDoc,  collection,  getDocs,  query,  where, Timestamp, doc, updateDoc} from "firebase/firestore";
import { PersonCheck, PersonCheckFill} from "react-bootstrap-icons";
import Header from './components/Header';
import Footer from './components/Footer';
import './qrreader.css';


const GoodieBagScanner = () => {
  const [user, loading, error] = useAuthState(auth);
  const [name, setName] = useState("");
  const [isAdmin, setIsAdmin] = useState(false);

  const location = useLocation();
  let tmpLocation;
  if (location.state) 
    tmpLocation = location.state.hotel;
  else {
   
  }
 
  const [message, setMessage] = useState([]);
  const [ticketDetails, setTicketDetails] = useState([]);
  const [clubMembers, setClubMembers] = useState([]);
  const [showClubMembers, setShowClubMembers] = useState(false);
  const allowedFields = ["roommates", "riderprofile", "udf2", "transactionId", "amount", "club", "tshirt", "food", "name"];

 

  const fetchLocalUserDetails = async (pnr, bobmcId, accommodationType) => {
    //   const users = JSON.parse(localStorage.getItem("users"));
    const docRef = doc(db, "RiderMania", "2026", "Registrations", pnr);

    // 2. Fetch the document snapshot
    const querySnapshot = await getDoc(docRef);
    
    //  const query1 = query(c
    if(querySnapshot.empty)
    {      
        console.log("No user found with this PNR.");
        setMessage(
          <>
            Please check the pnr            
          </>
        );
        alert("Please check the pnr ");    
        setTicketDetails("")
      
    }
    else{

      const data = querySnapshot.data();
      const dTicket = displayResults(data, pnr);
      if(data.goodieBagStatus === true){
       
        setMessage("Goodie bag already collected ");
                 
        
      }
      else {
        setMessage("");
        await updateStatusChecked(querySnapshot.id)      
        setTicketDetails(dTicket)
      }
    }
   
   
  };

   const updateStatusChecked = async (id) => {
    // remote Db update
  
    const checkinData = {
      goodieBagStatus: true, 
    
    } 
    try {
      
      const docRef = doc(db, "RiderMania", "2026", "Registrations", id);

    await  updateDoc(docRef, checkinData);
       // Update the local state to reflect the change
       setClubMembers(prevMembers => 
        prevMembers.map(member => 
          member.id === id 
            ? { ...member, goodieBagStatus: true}
            : member
        )
      );  
    
    
    } catch (e) {
      console.error("Error updating goodie bag status:", e);
    }
  
  
  };


  const displayResults = (data, pnr) => {
          
    const ticket = {};
   
    ticket["type"] = data.udf2;       
      ticket["pnr"] = data.riderprofile;
      ticket["name"] = data.name;
      ticket["tshirt"] = data.tshirt;
      ticket["club"] = data.club;
       
    
    //   setResult(ticket);
    return ticket
  };

  useEffect(() => {
    if (loading) return;
    if (!user) return navigate("/");

    setName(user?.email);
   
  }, [user, loading]);

  const navigate = useNavigate();

  const previewStyle = {
    height: 240,
    width: 320,
  };
  const constraints = {
    facingMode: "environment",
  };
  const [result, setResult] = useState("No result");

  const  handleScan = (data) => {
   
    if (data) {
      try {
        const parsedData = JSON.parse(data);
        if (parsedData.regId) {
          fetchLocalUserDetails(parsedData.regId, parsedData.bobmcId, parsedData.accommodation);
          return;
        }
      } catch (e) {
        console.log("QR code is not JSON, attempting regex match.");
      }
      
    }
  }; 

  const handleError = (error) => {
    console.error(error);
  };

  const fetchClubMembers = async (clubName) => {
    try {
      const q = query(collection(db, "RiderMania", "2026", "Registrations"), where("club", "==", clubName));
      const querySnapshot = await getDocs(q);
      const members = querySnapshot.docs.map(doc => ({

        id: doc.id,
        ...doc.data()
      }))
    
      .filter(member => member.status === "success"); // Filter out members without PNR
      // Sort the users list 
      members.sort((a, b) => { 
      if (a.name < b.name) 
        return -1; 
      if (a.name > b.name) 
        return 1; 
      return 0; 
    });
      
      setClubMembers(members);
      setShowClubMembers(true);
    } catch (error) {
      console.error("Error fetching club members:", error);
     
    }
  };

  const removeStatusChecked = async (id) => {
    // Show confirmation dialog
    const isConfirmed = window.confirm("Are you sure you want to remove the goodie bag status?");
    
    if (!isConfirmed) {
      return; // Exit if user cancels
    }
  
    // Remove check-in data
    const checkinData = {
      goodieBagStatus: false,            
     
    } 
  
    try {
      const docRef = doc(db, "RiderMania", "2026", "Registrations", id); 
      await updateDoc(docRef, checkinData);
      
      // Update the local state to reflect the change
      setClubMembers(prevMembers => 
        prevMembers.map(member => 
          member.id === id 
            ? { ...member, goodieBagStatus: false}
            : member
        )
      );  
        
    } catch (error) {
      console.error("Error removing goodie bag status:", error);
      alert("Error removing goodie bag status");
    } 
  };

  return (
    <>
    <div className="dashboard-container">
    <Header 
     title="Goodie Bag Scanner"
     showBack={false}
     showDashboard={true}   
   />

    
      {user ? (
        <main className="dashboard-main">
        
            <div align="center">
             
              <div className="text-danger">{message}</div>
              <br />
          
              <QrReader
                delay={500}
                onError={handleError}
                onScan={handleScan}
                style={previewStyle}
                facingMode={"environment"}
              />
            </div>
            
          <br clear="all" />
         
          <div style={{ marginTop: '6em' , marginBottom:'2em' ,color: 'var(--text-color, #f8f9fa) '} }>
             
          {/* Ticket Details Table */}
          {!showClubMembers && Object.entries(ticketDetails).filter(([key]) => allowedFields.includes(key)).map(([key, value]) => (
         <div className="ticket-details-container" key={key}>    
              <div className="trow" >
                <div className="cell uppercase">
                  <strong>{key}</strong>
                </div>
                <div className="cell text-break">
                  {key === "club" ? (
                   <div className="" style={{ color: 'var(--text-color, #f8f9fa) '}}>
                  
                      <span className="me-2">{value}</span>
                      <button 
                        className="btn btn-sm btn-primary"
                        onClick={() => fetchClubMembers(value)}
                      >
                        View
                      </button>
                    </div>
                  ) : (typeof value === 'object' && value !== null ? (
                      value.seconds ? new Date(value.seconds * 1000).toLocaleString() : JSON.stringify(value)
                    ) : <h3>{value}</h3>
                  )}
                </div>
              </div>
            </div>
          ))}
         
          {/* Club Members Table */}
          {showClubMembers && (
               <div style={{ color: 'var(--text-color, #f8f9fa) '}}>
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h4>Club Members</h4>
                <button 
                  className="btn btn-secondary"
                  onClick={() => setShowClubMembers(false)}
                  style={{ color: 'var(--text-color, #f8f9fa) '}}
                >
                  Back
                </button>
              </div>
              <div className="table-responsive">
                <table className="table" style={{ color: 'var(--text-color, #f8f9fa) ',backgroundColor: 'var(--card-bg-color, #212529)'}}>
                  <thead>
                  <tr>
                      <th>Name<br></br>Rider Profile</th>               
                            
                      <th>Goodie Bag Status</th>
                    </tr>
                  </thead>
                  <tbody>
                  {clubMembers.map((member) => (
                      <tr key={member.id}>
                        <td>{member.name}<br></br>{member.riderprofile}</td>                                      
                        <td>
                          {member.goodieBagTime ? (
                            <span className="text-success">
                              <PersonCheckFill className="text-success" size={20} onClick={()=> removeStatusChecked(member.id) }/>
                            </span>
                          ) : (
                            <span style={{ cursor: 'pointer' }} className="text-warning"><PersonCheck className="text-warning" size={20} onClick={()=> updateStatusChecked(member.id) }/></span>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
          </div>
        </main>

      ) : (
        
          <h3>404 Page Not Found </h3>
       
      )}
     
    </div>
    <Footer />
    </>
  );
};

export default GoodieBagScanner;
